"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userJobParsers = void 0;
const auto_layout_1 = require("./auto_layout");
const autoPlacement_1 = require("./autoPlacement");
const extractComponentsFromDatasheet_1 = require("./extractComponentsFromDatasheet");
const importComponentsFromDatasheet_1 = require("./importComponentsFromDatasheet");
exports.userJobParsers = {
    getDatasheetComponent: extractComponentsFromDatasheet_1.extractComponentsFromDatasheetJobSchema.parse,
    importComponentFromDatasheet: importComponentsFromDatasheet_1.importComponentsFromDatasheetJobSchema.parse,
    autoLayout: auto_layout_1.AutoLayoutJob.parse,
    autoPlacement: autoPlacement_1.AutoPlacementJob.parse,
};
//# sourceMappingURL=job.js.map